import { LE_CONTRACTED_HOTEL_TYPES } from 'constants/offer'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'

/** Initial rollout markets for the local destination offer carousel below trending destinations */
export const LOCAL_DESTINATION_OFFER_CAROUSEL_REGIONS = new Set(['FR', 'DE'])

/**
 * Synthetic chip value for the default multi-destination stream search.
 * Not a place id — pass `isLocalDestinationOfferAllFilter` as
 * `shouldKeepBaseDestinationFilters` so OfferCardCarouselSection keeps the base multi-place filters.
 */
export const LOCAL_DESTINATION_OFFER_ALL_FILTER_VALUE = 'all'

/** English analytics label for the All chip — not for customer-facing search URLs. */
export const LOCAL_DESTINATION_OFFER_ALL_DESTINATION_NAME = 'All'

/**
 * Stop waiting for unresolved eligibility checks and show or hide based on resolved destinations.
 *
 * When this elapses we leave the skeleton and freeze the current eligible set for All stream,
 * chips, and View All. Late light-search responses after freeze do not expand that set (stable
 * offer-list key). If timeout fires with zero eligible destinations, the module stays hidden
 * until a late eligible result arrives (then freezes) or all checks complete empty.
 */
export const LOCAL_DESTINATION_OFFER_ELIGIBILITY_TIMEOUT_MS = 10_000

export const LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS: App.OfferListFilters = {
  offerTypes: LE_CONTRACTED_HOTEL_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

export function isLocalDestinationOfferAllFilter(value: string | undefined): boolean {
  return value === LOCAL_DESTINATION_OFFER_ALL_FILTER_VALUE
}

/**
 * Default "All" list: hotel stream search across trending destinations.
 * Stream accepts multiple placeIds and uses hotel recommended ranking (MPV-primary),
 * unlike unified recommended which sorts by dailySales.
 */
export function buildLocalDestinationOfferAllFilters(
  destinationIds: Array<string>,
): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    destinationIds,
    isStream: true,
  }
}

/** Single-destination chip list: light-search default MPV for one place */
export function buildLocalDestinationOfferListFilters(destinationId: string): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    destinationId,
  }
}
